const selectors = {
    readMoreBtn: document.querySelector('[data_read_more]'),
    readMoreContainer: document.querySelector('.collection-description')
  };
  class templateCollectionJS {
    constructor() {
        this.readMore();

        var scrollToTopFilter = document.querySelector('#scroll-top-filter-btn');
        if (scrollToTopFilter) {
            scrollToTopFilter.addEventListener('click', function (e) {
                e.stopImmediatePropagation();
                document.querySelector('#CollectionFiltersForm .filter__wrapper').scrollTo({top: 0, behavior: 'smooth'});
            })
        }
    }

    readMore(){
        if(selectors.readMoreBtn){
            selectors.readMoreBtn.addEventListener('click', (e)=>{
                e.preventDefault();
                let currentTarget = e.target;
                if(currentTarget){ 
                    if(selectors.readMoreContainer.classList.contains('open')){
                        Utility.toggleElement(selectors.readMoreContainer, 'close');
                        selectors.readMoreContainer.classList.remove('open');
                        currentTarget.innerHTML = 'Read More'
                    }else{
                        Utility.toggleElement(selectors.readMoreContainer, 'open');
                        selectors.readMoreContainer.classList.add('open');
                        currentTarget.innerHTML = 'Read Less'
                    }
                }
            });
        }
    }

    selectUniversalTypeFilter() {
        if (document.querySelector('[value="universal-fit"][checked]') == null) {
            document.querySelector('[title="Universal Fit"]').click();
            document.querySelector('[value="universal-fit"]').setAttribute('checked', 'checked');   
        }
    }
}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();

 